// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterDiscoveryPartition
 */
export interface ClusterDiscoveryPartition {
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  cloudProvider?: ClusterDiscoveryPartitionCloudProviderEnum;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  plane?: ClusterDiscoveryPartitionPlaneEnum;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  relation?: ClusterDiscoveryPartitionRelationEnum;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryPartition
   */
  scope?: ClusterDiscoveryPartitionScopeEnum;
}

/**
 * @export
 */
export const ClusterDiscoveryPartitionCloudProviderEnum = {
  Aws: 'aws',
  Gcp: 'gcp',
  Azure: 'azure',
} as const;
export type ClusterDiscoveryPartitionCloudProviderEnum =
  (typeof ClusterDiscoveryPartitionCloudProviderEnum)[keyof typeof ClusterDiscoveryPartitionCloudProviderEnum];

/**
 * @export
 */
export const ClusterDiscoveryPartitionPlaneEnum = {
  Control: 'control',
  DataApplication: 'data-application',
  Management: 'management',
} as const;
export type ClusterDiscoveryPartitionPlaneEnum =
  (typeof ClusterDiscoveryPartitionPlaneEnum)[keyof typeof ClusterDiscoveryPartitionPlaneEnum];

/**
 * @export
 */
export const ClusterDiscoveryPartitionRelationEnum = {
  Self: 'Self',
  Other: 'Other',
} as const;
export type ClusterDiscoveryPartitionRelationEnum =
  (typeof ClusterDiscoveryPartitionRelationEnum)[keyof typeof ClusterDiscoveryPartitionRelationEnum];

/**
 * @export
 */
export const ClusterDiscoveryPartitionScopeEnum = {
  Global: 'global',
  Csp: 'csp',
  Regional: 'regional',
  Unrestricted: 'unrestricted',
} as const;
export type ClusterDiscoveryPartitionScopeEnum =
  (typeof ClusterDiscoveryPartitionScopeEnum)[keyof typeof ClusterDiscoveryPartitionScopeEnum];

/**
 * Check if a given object implements the ClusterDiscoveryPartition interface.
 */
export function instanceOfClusterDiscoveryPartition(
  value: object,
): value is ClusterDiscoveryPartition {
  return true;
}

export function ClusterDiscoveryPartitionFromJSON(
  json: any,
): ClusterDiscoveryPartition {
  return ClusterDiscoveryPartitionFromJSONTyped(json, false);
}

export function ClusterDiscoveryPartitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterDiscoveryPartition {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    name: json['name'] == null ? undefined : json['name'],
    plane: json['plane'] == null ? undefined : json['plane'],
    region: json['region'] == null ? undefined : json['region'],
    relation: json['relation'] == null ? undefined : json['relation'],
    scope: json['scope'] == null ? undefined : json['scope'],
  };
}

export function ClusterDiscoveryPartitionToJSON(
  json: any,
): ClusterDiscoveryPartition {
  return ClusterDiscoveryPartitionToJSONTyped(json, false);
}

export function ClusterDiscoveryPartitionToJSONTyped(
  value?: ClusterDiscoveryPartition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    name: value['name'],
    plane: value['plane'],
    region: value['region'],
    relation: value['relation'],
    scope: value['scope'],
  };
}
